import React, { useState, useEffect, Fragment } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Section } from "../../../shared";
import { AlertBanner } from "../../../shared";
import {
  otherReports,
  handlerReports,
  tonnageReports,
  transporterReports,
} from "./ReportTableConfig";
import { ListGroup, Row, Col } from "react-bootstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { useIsRegulator, useIsSystemAdmin, useHasUserAgrmt, useAlertBanner, useIsBulkManifest } from "../../../../hooks";
import { Breadcrumbs } from "../../../ssi";
import { UserAgrmtModal } from "../../landing-page";
import { useLocation } from "react-router-dom";

function Reports(props) {
  const [hReports, setHReports] = useState([]);
  const [tReports, setTReports] = useState([]);
  const [eReports, setEReports] = useState([]);
  const user = useSelector((state) => state.user);
  const isSystemAdmin = useIsSystemAdmin();
  const isRegulator = useIsRegulator();
  const alerts = useAlertBanner();
  let location = useLocation();
  const hasUserAgrmt = useHasUserAgrmt();
  const isBulkManifest = useIsBulkManifest();

  useEffect(() => {
    if (!user.isAuth || isRegulator === false || (!hasUserAgrmt || hasUserAgrmt === false)) {
      setHReports(
        handlerReports.filter(
          (report) => !report.isRegulatory || report.isRegulatory !== true
        )
      );
      setTReports(
        tonnageReports.filter(
          (report) => !report.isRegulatory || report.isRegulatory !== true
        )
      );
      setEReports(
        transporterReports.filter(
          (report) => !report.isRegulatory || report.isRegulatory !== true
        )
      );
    } else {
      setHReports(handlerReports);
      setTReports(tonnageReports);
      setEReports(transporterReports);
    }
  }, [isRegulator, isSystemAdmin, hasUserAgrmt]);

  return (
    <div className="">
      {(user.isAuth && hasUserAgrmt === false && !isBulkManifest) &&
        <UserAgrmtModal hasUserAgrmt={hasUserAgrmt} />
      }
      <Section
        title={
          <Link to="/reports" style={{ color: "white" }}>
            HWTS Reports
          </Link>
        }
        type={"standout"}
      />
      {location.pathname === "/reports" &&
        alerts.map((alert) => {
          if (alert.link === "/reports") {
            return <AlertBanner alert={alert} key={alert.id} />
          }
        })
      }
      <div className="container">
        <Breadcrumbs
          breadcrumbs={[
            { name: "HWTS Reports", url: "/reports", active: true },
          ]}
        />
        <h2 className="reports-section-title">Handler Reports</h2>
        <ListGroup>
          {hReports.map((r, i) => (
            <ListGroup.Item
              action
              key={r.report}
              style={{ margin: "0px 0px" }}
            >
              <Link to={r.url}>
                <Row style={{ fontSize: ".9em" }}>
                  <Col lg={1} xs={1}>
                    {i + 1}
                  </Col>
                  <Col lg={3} xs={11}>
                    <Link to={r.url}>{r.report}</Link>
                  </Col>
                  <Col lg={8} sm={12}>
                    {r.description}
                  </Col>
                </Row>
              </Link>
            </ListGroup.Item>
          ))}
        </ListGroup>
        <h2 className="reports-section-title">Manifest & Tonnage Reports</h2>
        <ListGroup>
          {tReports.map((r, i) => (
            <ListGroup.Item
              action
              key={r.report}
              style={{ margin: "0px 0px" }}
            >
              <Link to={r.url}>
                <Row style={{ fontSize: ".9em" }}>
                  <Col lg={1} xs={1}>
                    {i + 1}
                  </Col>
                  <Col lg={3} xs={11}>
                    <Link to={r.url}>{r.report}</Link>
                  </Col>
                  <Col lg={8} sm={12}>
                    {r.description}
                  </Col>
                </Row>
              </Link>
            </ListGroup.Item>
          ))}
        </ListGroup>

        {user.isAuth && isRegulator && hasUserAgrmt && (
          <div>
            <h2 className="reports-section-title">Transporter Reports</h2>
            <ListGroup>
              {eReports.map((r, i) => (
                <ListGroup.Item
                  action
                  key={r.report}
                  style={{ margin: "0px 0px" }}
                >
                  <Link to={r.url}>
                    <Row style={{ fontSize: ".9em" }}>
                      <Col lg={1} xs={1}>
                        {r.reportNumber}
                      </Col>
                      <Col lg={3} xs={11}>
                        <Link to={r.url}>{r.report}</Link>
                      </Col>
                      <Col lg={8} sm={12}>
                        {r.description}
                      </Col>
                    </Row>
                  </Link>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </div>
        )}

        {user.isAuth && isSystemAdmin && (
          <div>
            <h2 className="reports-section-title">Other Reports</h2>
            <ListGroup>
              {otherReports.map((r, i) => (
                <ListGroup.Item
                  action
                  key={r.report}
                  style={{ margin: "0px 0px" }}
                >
                  <Link to={r.url}>
                    <Row style={{ fontSize: ".9em" }}>
                      <Col lg={1} xs={1}>
                        {r.reportNumber}
                      </Col>
                      <Col lg={3} xs={11}>
                        <Link to={r.url}>{r.report}</Link>
                      </Col>
                      <Col lg={8} sm={12}>
                        {r.description}
                      </Col>
                    </Row>
                  </Link>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </div>
        )}
        <br />
        <div className="m-b-sm">
          If the reports listed above do not meet your needs, you can request a
          custom report (for a fee) by sending your request via email to{" "}
          <a href="mailto:>hwtsreports@dtsc.ca.gov">hwtsreports@dtsc.ca.gov</a>.
        </div>
      </div>
    </div>
  );
}

export default Reports;
